<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">

				<el-form-item label="申报状态" label-width='70px'>
					<el-select clearable v-model="secah.achStatus" placeholder="请选择申报状态">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="申报中" :value="1"></el-option>
						<el-option label="申报成功" :value="2"></el-option>
						<el-option label="申报失败" :value="3"></el-option>

					</el-select>
				</el-form-item>
				<el-form-item label="申报类型" label-width='70px'>
					<el-select clearable v-model="secah.achType" placeholder="请选择申报类型">
						<el-option label="全部" value=""></el-option>
						<el-option label="国珍" :value="1"></el-option>
						<el-option label="荐康客" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>

			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="achAmount" label="申报数量" align="center"></el-table-column>
				<el-table-column  label="申报状态" align="center">
					<template slot-scope="scope">
						{{scope.row.achStatus==1?"审核中":scope.row.withdrawalStatus==2?"申报成功":"申报失败"}}
					</template>
				</el-table-column>
				<el-table-column label="申报类型" align="center">
					<template slot-scope="scope">
						{{scope.row.achType==1?"国珍":"荐康客"}}
					</template>
				</el-table-column>
				<el-table-column label="是否有卡号" align="center">
					<template slot-scope="scope">
						{{scope.row.isHaveCard==1?"是":"否"}}
					</template>
				</el-table-column>
				<el-table-column prop="cardNo" label="国珍/荐康客卡号" align="center"></el-table-column>
				<el-table-column prop="fullName" label="真实姓名" align="center"></el-table-column>
				<el-table-column prop="createTime" label="申报时间" align="center"></el-table-column>
				<el-table-column prop="bankName" label="银行名称" align="center"></el-table-column>
				<el-table-column prop="bankNo" label="银行卡号" align="center"></el-table-column>
				<el-table-column prop="referrerName" label="推荐人姓名" align="center"></el-table-column>
				<el-table-column prop="referrerCardNo" label="推荐人卡号" align="center"></el-table-column>
				<el-table-column prop="tel" label="电话号码" align="center"></el-table-column>
				<el-table-column  label="身份证正面" align="center" width="120">
					<template slot-scope="scope">
						<!-- <img :src="scope.row.url" style="width: 200px; height: 150px;" /> -->
						<viewer>
							<img :src="webUrl+scope.row.idCardFront" style="width: 70px; height: 30px;">
						</viewer>
					</template>
				</el-table-column>
				<el-table-column  label="身份证反面" align="center" width="120">
					<template slot-scope="scope">
						<!-- <img :src="scope.row.url" style="width: 200px; height: 150px;" /> -->
						<viewer>
							<img :src="webUrl+scope.row.idCardBack" style="width: 70px; height: 30px;">
						</viewer>
					</template>
				</el-table-column>
				<el-table-column prop="failReason" label="失败原因" width="150" align="center"></el-table-column>
				<el-table-column fixed="right" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type="success" v-if="scope.row.achStatus==1"  size="mini" @click="agreeWithdrawal(scope.row)">申请通过</el-button>
						<el-button type="danger" v-if="scope.row.achStatus==1"  size="mini" @click="refuseWithdrawal(scope.row)">拒绝申请</el-button>	
						<!-- <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="warning" @click="reset(scope.row)">重置密码</el-button> -->
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="拒绝原因" :visible.sync="isreason" :modal-append-to-body='false' width="600px">
				<el-form>
					
					<el-form-item label="拒绝原因" label-width='80px'>
						<el-input type="textarea" v-model="failReason" maxlength="10" autocomplete="off" placeholder="请输入拒绝原因"></el-input>
					</el-form-item>
					
				
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="isreason = false">取 消</el-button>
					<el-button type="primary" @click="sub">确 定</el-button>
				</div>
			</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				total: 0,
				isreason:false,
				failReason:"",
				secah: {
					pageSize: 10,
					pageNum: 1,
					achStatus: 0,//业绩申报状态 1申报中2申报成功3申报失败 不传或者传0表示全部
					achType:"",
				},
				achievementId:""

			}
		},
		created() {
			this.getList()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getList()
			},

			//通过
			agreeWithdrawal(row){
				this.$confirm('确定通过当前申报申请?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpPost('/pc/achievement/agree?achievementId='+row.achievementId).then(res => {
						if (res.code == 200) {
							this.$message.success('操作成功');
							this.dialogVisible = false
							this.getList()
							// this.getUserList()
						}
					})
				}).catch(() => {});
			},
			//拒绝通过
			refuseWithdrawal(row){
				this.isreason=true
				this.achievementId=row.achievementId	
				this.failReason=''	
			},
			//确定拒绝通过
			sub(){
				this.httpPost('/pc/achievement/refuse?achievementId='+this.achievementId+"&failReason="+this.failReason).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
						this.isreason = false
						this.getList()
						
						// this.getUserList()
					}
				})
			},


			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getList()
			},
			//获取数据
			getList() {
				var secah=this.secah
				// secah.withdrawalStatus=secah.withdrawalStatus?secah.withdrawalStatus:0
				this.httpPost("/pc/achievement/pcListByPage", secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},


		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
